import call from "@kinetics254/cassandra-base/service/http";
import constants from "./trainingConstants";

export default {
  namespaced: true,
  state: {
    trainings: [],
    training: {},
    allTrainings: [],
    trainee: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    trainingGetters: (state) => (val) => state[val],
  },
  actions: {
    getTrainings: ({ commit }) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.trainingDocuments)
        .then((res) => {
          console.log("training", res.data.data);
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "trainings", data: res.data.data });
        })
        .catch((error) => {
          console.log("error", error);
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    getAllTrainings: ({ commit }) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.allTrainings)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "allTrainings", data: res.data.data });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    getTraining: ({ commit }, no) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.trainingDocument(no))
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "training", data: res.data.data[0] });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    addTraining: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.trainingDocuments, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          if (res && data.submitRecall) {
            dispatch("sendForApproval", { docNo: res.data.data[0].no });
          } else {
            dispatch("getTrainings");
            Event.$emit("closeDialog");
          }
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    updateTraining: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("patch", constants.updateTraining, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          console.log(res.data.data);
          if (res && data.submitRecall) {
            dispatch("sendForApproval", { docNo: res.data.data[0].no });
          } else {
            // Event.$emit("closeDialog");
            dispatch("getTrainings");
            dispatch("getTraining", data.no);
          }
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    deleteTraining: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.deleteTraining, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          Event.$emit("closeDialog");
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    deleteTrainingLineItem: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      const no = data.documentNo;
      call("delete", constants.deleteLine, { data })
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTraining", no);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    sendForApproval: ({ commit, dispatch }, no) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.sendForApproval, no)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          dispatch("getTraining", no.docNo);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    cancelApproval: ({ commit, dispatch }, no) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.cancelApproval, no)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          dispatch("getTraining", no.docNo);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    reopenDocument: ({ commit, dispatch }, no) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.reopenDocument, no)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          dispatch("getTraining", no.docNo);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    deleteTrainee: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      const no = data.documentNo;
      call("delete", constants.deleteTrainee, { data })
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTraining", no);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    addTrainee: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      const no = data.documentNo;
      call("post", constants.addTrainee, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTraining", no);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    getTrainee: ({ commit }) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.trainee)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "trainee", data: res.data.data });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    deleteAttachment: ({ commit, dispatch }, data) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.deleteAttachment, data)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTraining", data.no);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    sendDocForApproval: ({ commit, dispatch }, no) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.sendDocForApproval, no)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          dispatch("getTraining", no.docNo);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    uploadTrainingDoc: ({ commit, dispatch }, payload) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.uploadTrainingDoc, payload)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          dispatch("getTraining", payload.docNo);
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    async downloadUploadedReport({ commit, dispatch }, payload) {
      commit("loader/SET_LOADING", true, { root: true });

      try {
        const res = await call("get", constants.downloadTrainingDoc(payload));
        commit("loader/SET_LOADING", false, { root: true });
        const file = res.data.data[0];

        dispatch("openBase64InNewTab", {
          base64String: file.attachment,
          fileName: file.fileName,
        });
      } catch (error) {
        commit("loader/SET_LOADING", false, { root: true });
        console.error(error);
      }
    },
    saveProgramme: ({ commit, dispatch }, payload) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("post", constants.saveProgramme, payload)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          dispatch("getTrainings");
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    deleteTrainingLine: async ({ commit, dispatch }, payload) => {
      try {
        commit("loader/SET_LOADING", true, { root: true });
        await call("post", constants.deleteTrainingLine, payload);
        commit("loader/SET_LOADING", false, { root: true });
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        commit("loader/SET_LOADING", false, { root: true });
      }
    },

    openBase64InNewTab(
      _,
      { base64String, fileName = "file", mimeType = "application/pdf" }
    ) {
      try {
        if (!base64String || typeof base64String !== "string") {
          console.error("Invalid Base64 string");
          return;
        }

        // Decode Base64
        const byteCharacters = atob(base64String);
        const byteArrays = [];

        // Convert to Uint8Array in chunks (handles large files safely)
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        // Create Blob
        const blob = new Blob(byteArrays, { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        // Open file in new tab
        const newTab = window.open();
        if (newTab) {
          newTab.location.href = blobUrl;
        } else {
          alert("Please allow popups to view the file.");
        }

        // Cleanup memory
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
      } catch (error) {
        console.error("Failed to open Base64 file:", error);
      }
    },
  },
};
